//components
import Panel from "../../../ui/Panel/Panel";
import LoginForm from "../form/LoginForm";

//Styles and scss
import logo from "../../../assets/images/Logo_Nexi_Group_Orizz_Colore.png";
import classes from "./Login.module.scss";

//messages
import { FormattedMessage } from "react-intl";
import LanguageSelect from "../../../components/LanguageSelect/LanguageSelect";
import messages from "../module/messages";

export const Login = () => {
  return (
    <div className={classes.wrapper}>
      <div className="container-fluid">
        <div className="row d-flex justify-content-center flex-wrap">
          <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 m-3">
            <Panel title={<FormattedMessage {...messages.title} />}>
              <div className="row d-flex justify-content-center">
                <img
                  className={classes["image-wrapper"]}
                  src={logo}
                  alt="Nexi logo"
                />
              </div>
              <LoginForm />
              <div className="row d-flex justify-content-center flex-wrap">
                <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 m-3">
                  <LanguageSelect colorPrimary={true} />
                </div>
              </div>
            </Panel>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
